import { Details, useDetailsState } from 'components/Atoms/Details'
import { PanelSectionBaseCSS } from './PanelSectionBaseCSS.styled'
import { useEffect, useState } from 'react'
import { useLayoutV3State } from 'hooks/useLayoutV3State'
import { SingleContentToggle } from 'components/Atoms/SingleContentToggle'

const doNothing = () => null

export const PanelSectionBase = ({
  openPanelSummary,
  closePanelSummary,
  content,
  open = false,
  onSummaryClick = doNothing,
}) => {
  const { isOpenLeftPanel, setOpenLeftPanel } = useLayoutV3State()
  const detailsState = useDetailsState({ open: isOpenLeftPanel && open })
  const [prevOpen, setprevOpen] = useState(open)

  useEffect(() => {
    if (!isOpenLeftPanel) {
      setprevOpen(detailsState.open)
      detailsState.setOpen(false)
    } else {
      detailsState.setOpen(prevOpen)
    }
  }, [isOpenLeftPanel])

  useEffect(() => {
    if (!isOpenLeftPanel) {
      setprevOpen(open)
    } else {
      detailsState.setOpen(open)
    }
  }, [open])

  const clickHandler = () => {
    if (!isOpenLeftPanel) {
      setOpenLeftPanel(true)
      detailsState.setOpen(true)
    }
    onSummaryClick()
  }

  return (
    <PanelSectionBaseCSS isPanelOpen={isOpenLeftPanel} onClick={clickHandler}>
      <Details className='dropdown' {...detailsState} isOpenBlocked={!isOpenLeftPanel}>
        <summary className={detailsState.open ? 'open' : 'close'} role='button'>
          <SingleContentToggle
            noWrapper
            toggle={isOpenLeftPanel}
            trueContent={
              <>
                {openPanelSummary}
                <svg className={`plus ${detailsState.open && 'open'}`} viewBox='0 0 16 16'>
                  <path d='M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z'></path>
                </svg>
              </>
            }
            falseContent={closePanelSummary}
          />
        </summary>
        <div className='content'>{content}</div>
      </Details>
    </PanelSectionBaseCSS>
  )
}
